import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
const Footer = () => {
  const navigate = useNavigate();

  const handleBookConsultation = () => {
    navigate("/contact"); // Replace with your actual contact page route
  };
  return (
    <footer className="footer">
      <Button
        style={{
          backgroundColor: "#FECA0A", // Your custom background color
          color: "#3A0063", // Your custom text color
          borderColor: "#FECA0A", // Optional: match border color
        }}
        className="mt-2"
        onClick={handleBookConsultation}
      >
        <strong>Book a Consultation</strong>
      </Button>
    </footer>
  );
};

export default Footer;
